
// @ts-nocheck


export const localeCodes =  [
  "en",
  "de",
  "es",
  "fr",
  "it",
  "pl",
  "pt",
  "ru",
  "uk",
  "ja",
  "ko",
  "zh"
]

export const localeLoaders = {
  "en": [{ key: "../lang/en.json", load: () => import("../lang/en.json" /* webpackChunkName: "locale__app_dev_lang_en_json" */), cache: true },
{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "de": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "es": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "fr": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "it": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "pl": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "pt": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "ru": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "uk": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "ja": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "ko": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }],
  "zh": [{ key: "../lang/load.js", load: () => import("../lang/load.js?hash=4034aa89&locale=en" /* webpackChunkName: "locale__app_dev_lang_load_js" */), cache: false }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.js?hash=c231e734&config=1" /* webpackChunkName: "i18n_config_c231e734" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "files": [
        "/app/dev/lang/en.json",
        "/app/dev/lang/load.js"
      ],
      "region": "US",
      "name": "English (US)",
      "localizedName": "English (United States)",
      "language": "en-US"
    },
    {
      "code": "de",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "DE",
      "name": "German (Germany)",
      "localizedName": "Deutsch (Germany)",
      "language": "de-DE"
    },
    {
      "code": "es",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "ES",
      "name": "European Spanish",
      "localizedName": "Español (Spain)",
      "language": "es-ES"
    },
    {
      "code": "fr",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "FR",
      "name": "French (France)",
      "localizedName": "Français (France)",
      "language": "fr-FR"
    },
    {
      "code": "it",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "IT",
      "name": "Italian (Italy)",
      "localizedName": "Italiano (Italy)",
      "language": "it-IT"
    },
    {
      "code": "pl",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "PL",
      "name": "Polish (Poland)",
      "localizedName": "Polski (Poland)",
      "language": "pl-PL"
    },
    {
      "code": "pt",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "PT",
      "name": "European Portuguese",
      "localizedName": "Português (Portugal)",
      "language": "pt-PT"
    },
    {
      "code": "ru",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "RU",
      "name": "Russian (Russia)",
      "localizedName": "Русский (Russia)",
      "language": "ru-RU"
    },
    {
      "code": "uk",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "UA",
      "name": "Ukrainian (Ukraine)",
      "localizedName": "Українська (Ukraine)",
      "language": "uk-UA"
    },
    {
      "code": "ja",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "JP",
      "name": "Japanese (Japan)",
      "localizedName": "日本語 (Japan)",
      "language": "ja-JP"
    },
    {
      "code": "ko",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "KR",
      "name": "Korean (South Korea)",
      "localizedName": "한국어 (South Korea)",
      "language": "ko-KR"
    },
    {
      "code": "zh",
      "files": [
        "/app/dev/lang/load.js"
      ],
      "region": "HK",
      "name": "Chinese (Hong Kong SAR China, Simplified)",
      "localizedName": "中文 (China)",
      "language": "zh-HK"
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": true,
  "langDir": "lang",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": true,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "files": [
      {
        "path": "/app/dev/lang/en.json"
      },
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "US",
    "name": "English (US)",
    "localizedName": "English (United States)",
    "language": "en-US"
  },
  {
    "code": "de",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "DE",
    "name": "German (Germany)",
    "localizedName": "Deutsch (Germany)",
    "language": "de-DE"
  },
  {
    "code": "es",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "ES",
    "name": "European Spanish",
    "localizedName": "Español (Spain)",
    "language": "es-ES"
  },
  {
    "code": "fr",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "FR",
    "name": "French (France)",
    "localizedName": "Français (France)",
    "language": "fr-FR"
  },
  {
    "code": "it",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "IT",
    "name": "Italian (Italy)",
    "localizedName": "Italiano (Italy)",
    "language": "it-IT"
  },
  {
    "code": "pl",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "PL",
    "name": "Polish (Poland)",
    "localizedName": "Polski (Poland)",
    "language": "pl-PL"
  },
  {
    "code": "pt",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "PT",
    "name": "European Portuguese",
    "localizedName": "Português (Portugal)",
    "language": "pt-PT"
  },
  {
    "code": "ru",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "RU",
    "name": "Russian (Russia)",
    "localizedName": "Русский (Russia)",
    "language": "ru-RU"
  },
  {
    "code": "uk",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "UA",
    "name": "Ukrainian (Ukraine)",
    "localizedName": "Українська (Ukraine)",
    "language": "uk-UA"
  },
  {
    "code": "ja",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "JP",
    "name": "Japanese (Japan)",
    "localizedName": "日本語 (Japan)",
    "language": "ja-JP"
  },
  {
    "code": "ko",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "KR",
    "name": "Korean (South Korea)",
    "localizedName": "한국어 (South Korea)",
    "language": "ko-KR"
  },
  {
    "code": "zh",
    "files": [
      {
        "path": "/app/dev/lang/load.js"
      }
    ],
    "region": "HK",
    "name": "Chinese (Hong Kong SAR China, Simplified)",
    "localizedName": "中文 (China)",
    "language": "zh-HK"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = true
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
